import { Color, PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#F4F4F4',
  100: '#eeeeee',
  200: '#d5d5d5',
  300: '#c1c1c1',
  400: '#a0a0a0',
  500: '#7f7f7f',
  600: '#6b6b6b',
  700: '#4f4f4f',
  800: '#434343',
  900: '#333333',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary: PaletteColorOptions = {
  light: '#99DCAF',
  main: '#6CCB5F',
  dark: '#3FA746',
  contrastText: '#FFFFFF',
};

const secondary: PaletteColorOptions = {
  light: '#6FB1DB',
  main: '#3498DB',
  dark: '#1B70B1',
  contrastText: '#FFFFFF',
};

const info: PaletteColorOptions = {
  light: '#66C0C7',
  main: '#33A8A5',
  dark: '#21827B',
  contrastText: '#FFFFFF',
};

const success: PaletteColorOptions = {
  light: '#b7df9c',
  main: '#8BAD75',
  dark: '#648f54',
  contrastText: '#FFFFFF',
};

const warning: PaletteColorOptions = {
  light: '#ffe6c4',
  main: '#D9A356',
  dark: '#a1773e',
  contrastText: '#000000',
};

const error: PaletteColorOptions = {
  light: '#fca1a1',
  main: '#D95F5D',
  dark: '#a64343',
  contrastText: '#FFFFFF',
};

const trustfulPalette: PaletteOptions = {
  mode: 'light',
  action: {
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#333333',
    secondary: '#475569',
    disabled: '#a0a0a0',
  },
  background: { paper: '#fff', default: '#fff' },
};

export default trustfulPalette;
